import React from "react";
import EmployerListView from "./EmployerListView";

export default function EmployerList() {
  return <EmployerListView />;
}
